"use strict";

exports.__esModule = true;
exports.AlignmentPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Renders buttons for aligning elements vertically and horizontally.
 */
var AlignmentPicker = exports.AlignmentPicker = /*#__PURE__*/function (_Component) {
  function AlignmentPicker() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleAlignTopClick = function () {
      return _this.alignVertical("top");
    };
    _this.handleAlignRightClick = function () {
      return _this.alignHorizontal("right");
    };
    _this.handleAlignBottomClick = function () {
      return _this.alignVertical("bottom");
    };
    _this.handleAlignLeftClick = function () {
      return _this.alignHorizontal("left");
    };
    _this.handleAlignHorizontalCenterClick = function () {
      return _this.alignHorizontal("center");
    };
    _this.handleAlignVerticalCenterClick = function () {
      return _this.alignVertical("center");
    };
    return _this;
  }
  _inheritsLoose(AlignmentPicker, _Component);
  var _proto = AlignmentPicker.prototype;
  _proto.alignHorizontal = function alignHorizontal(horizontal) {
    var _this$props = this.props,
      value = _this$props.value,
      onChange = _this$props.onChange;
    onChange([horizontal, value ? value[1] : undefined]);
  };
  _proto.alignVertical = function alignVertical(vertical) {
    var _this$props2 = this.props,
      value = _this$props2.value,
      onChange = _this$props2.onChange;
    onChange([value ? value[0] : undefined, vertical]);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      value = _this$props3.value,
      direction = _this$props3.direction,
      large = _this$props3.large,
      minimal = _this$props3.minimal;
    var horizontalAlign = value ? value[0] : undefined;
    var verticalAlign = value ? value[1] : undefined;
    var allowHorizontal = direction === "both" || direction === "horizontal";
    var allowVertical = direction === "both" || direction === "vertical";
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
        large: large,
        minimal: minimal
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: horizontalAlign === "left",
        icon: _icons.IconNames.ALIGNMENT_LEFT,
        title: translate("AlignmentPicker.alignLeft.title", "Align Left"),
        onClick: _this2.handleAlignLeftClick,
        disabled: !allowHorizontal
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: horizontalAlign === "center",
        icon: _icons.IconNames.ALIGNMENT_HORIZONTAL_CENTER,
        title: translate("AlignmentPicker.alignHorizontal.title", "Align Horizontally"),
        onClick: _this2.handleAlignHorizontalCenterClick,
        disabled: !allowHorizontal
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: horizontalAlign === "right",
        icon: _icons.IconNames.ALIGNMENT_RIGHT,
        title: translate("AlignmentPicker.alignRight.title", "Align Right"),
        onClick: _this2.handleAlignRightClick,
        disabled: !allowHorizontal
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: verticalAlign === "top",
        icon: _icons.IconNames.ALIGNMENT_TOP,
        title: translate("AlignmentPicker.alignTop.title", "Align Top"),
        onClick: _this2.handleAlignTopClick,
        disabled: !allowVertical
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: verticalAlign === "center",
        icon: _icons.IconNames.ALIGNMENT_VERTICAL_CENTER,
        title: translate("AlignmentPicker.alignVertical.title", "Align Vertically"),
        onClick: _this2.handleAlignVerticalCenterClick,
        disabled: !allowVertical
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        active: verticalAlign === "bottom",
        icon: _icons.IconNames.ALIGNMENT_BOTTOM,
        title: translate("AlignmentPicker.alignButton.title", "Align Bottom"),
        onClick: _this2.handleAlignBottomClick,
        disabled: !allowVertical
      }));
    });
  };
  return AlignmentPicker;
}(_react.Component);
AlignmentPicker.defaultProps = {
  direction: "both"
};